import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch, nextTick } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import useIcons from '@/composables/useIcons'
  import eventBus from '@/main'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseSearch',
  setup(__props) {

  const searchText = ref('')
  const showSearchButton = ref(false)
  const { closeIcon } = useIcons()

  watch(searchText, (value: string) => {
    if (value) showSearchButton.value = true
    else {
      onSearch()
      nextTick(() => {
        showSearchButton.value = false
      })
    }
  })

  onMounted(() => {
    eventBus.$on('reset-search-term', () => {
      searchText.value = ''
    })
  })

  const onSearch = () => {
    eventBus.$emit('course-search-term', searchText.value)
  }

return { __sfc: true,searchText, showSearchButton, closeIcon, onSearch, onMounted, ref, watch, nextTick, KetchUpButton, useIcons, eventBus }
}

})